import type {
  DealInsightsFilterEntryApi,
  DealInsightsFilterNullableEntryApi,
  DealInsightsFilterOptionKeys,
} from '@openx/types/dealInsights';
import { dealInsightsFilterOptionKeys } from '@openx/types/dealInsights';
import type { TFunction } from 'i18next';
import { AD_SIZE_LABELS } from '../components/DealInsightsDelivery/sections/DeliveryByAdSizeTable/utils/adSizeLabels';

export const mapFilterOptionLabel = (
  option: DealInsightsFilterEntryApi | DealInsightsFilterNullableEntryApi,
  filterKey: DealInsightsFilterOptionKeys,
  t: TFunction
): string => {
  if (filterKey === dealInsightsFilterOptionKeys.CHANNEL && option.name === 'Site') {
    return 'Web';
  }

  if (filterKey === dealInsightsFilterOptionKeys.ADSIZE && option.name) {
    return AD_SIZE_LABELS[option.name as keyof typeof AD_SIZE_LABELS] ?? option.name;
  }

  if (option.name === null) {
    return t('Unknown');
  }

  return option.name ?? '';
};
